import {REJECTED_REANALYSIS_FEATURE_BY_HOST} from 'presentation/constants/rejectedReanalysisFeatureByHost';
import {useHostName} from 'presentation/hooks';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';

export const useRejectedReanalysisFeatureFlag = () => {
	const {
		dataHostNameState: {product},
	} = useHostName();

	return useFeatureFlag(REJECTED_REANALYSIS_FEATURE_BY_HOST[product]);
};
